module.exports = __webpack_public_path__ + "static/media/14.e90a840e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/japan-two/14.jpg
// module id = 468
// module chunks = 0